import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import PopUp from "../PopUp";
import api from "../api/api";
import FormGroup from "../form/FormGroup";
import List from "../List";
import FormGroupValue from "../form/FormGroupValue";

function InvoiceFormPopup({ address, refreshAddress }) {
	const { cart, setInvoiceFormPopup, setLoading, setConfirm, editCart2 } = useContext(AppContext);
	const [formAddress, setFormAddress] = useState(
		typeof address === "object" && address !== null
			? address
			: {
					company: "",
					vat: "",
					sdi: "",
					pec: "",
					taxcode: "",
					address: "",
					number: "",
					zipcode: "",
					city: "",
					province: "",
			  }
	);
	const [vat, setVat] = useState("");
	const [searchTerm2, setSearchTerm2] = useState("");

	useEffect(() => {
		console.log("address", formAddress);
		if (address && !cart.customer) {
			loadCustomer();
		}
	}, [address]);

	useEffect(() => {
		console.log("formAddress", formAddress);
	}, [formAddress]);

	const loadCustomer = async () => {
		if (address && address.customer_id) {
			setLoading(true);
			const res = await api.getProtected("/customers/get/" + address.customer_id + "/");
			setLoading(false);
			if (res.success == 0) {
				setConfirm({
					title: "Errore",
					message: res.error,
				});
			} else {
				editCart2({
					customer: res.data,
				});
			}
		}
	};

	const saveAddress = async (e) => {
		e.preventDefault();
		setLoading(true);
		const formData = new FormData(e.target);
		const data = Object.fromEntries(formData.entries());
		const customer = await addCustomer(data);
		let endpoint = "";
		console.log(address);
		const addressReq = {
			company: data.company,
			vat: data.vat,
			sdi: data.sdi,
			pec: data.pec,
			taxcode: data.taxcode,
			address: data.address,
			number: data.number,
			zipcode: data.zipcode,
			city: data.city,
			province: data.province,
		};
		if (address && address.id) {
			endpoint = "/addresses_billing/edit/" + address.id + "/";
		} else {
			endpoint = "/addresses_billing/add/";
			addressReq.customer_id = customer.id;
		}
		const res = await api.postProtected(endpoint, addressReq);
		setLoading(false);
		if (res.success == 1) {
			setInvoiceFormPopup(false);
			editCart2({
				customer: customer,
			});
		} else {
			setConfirm({
				title: "Errore",
				message: res.error,
			});
		}
	};

	const addCustomer = async (data) => {
		if (!cart.customer) {
			const customerReq = {
				name: data.name,
				surname: data.surname,
				mobile: data.mobile,
				email: data.email,
			};
			const res = await api.postProtected("/customers/add/", customerReq);
			if (res.success == 0) {
				setLoading(false);
				setConfirm({
					title: "Errore",
					message: res.error,
				});
			} else {
				return res.data;
			}
		} else return cart.customer;
	};

	const srcCompany = async () => {
		if (searchTerm2) {
			setLoading(true);
			const res = await api.postProtected("/pos2/src_company/", {
				src_param: searchTerm2,
			});
			setLoading(false);
			if (res.success == 0) alert(res.error);
			else
				setFormAddress({
					company: res.data.companyName,
					vat: res.data.vatCode,
					sdi: res.data.sdiCode,
					pec: "",
					taxcode: res.data.taxCode,
					address: res.data.address.registeredOffice.street,
					number: res.data.address.registeredOffice.streetNumber,
					zipcode: res.data.address.registeredOffice.zipCode,
					city: res.data.address.registeredOffice.town,
					province: res.data.address.registeredOffice.province,
				});
		}
	};

	return (
		<PopUp
			size=""
			customClass="invoice-form-popup"
			options={{
				onClose: () => setInvoiceFormPopup(false),
				title: "Fattura",
			}}
		>
			<div className="inner-content invoice-form-popup-content">
				<div className="input-group">
					<h4>Ricerca per PIVA o CF</h4>
					<input
						type="text"
						placeholder="Ricerca P.iva, C.F."
						autoFocus
						onChange={(e) => setSearchTerm2(e.target.value)}
						value={searchTerm2}
					/>
					<button onClick={() => srcCompany()}>Cerca</button>
				</div>
				<form onSubmit={saveAddress}>
					{!cart.customer && (
						<div className="invoice-block">
							<h4 className="invoice-title">Cliente</h4>
							<div className="form">
								<FormGroup id="name" name="name" label="Nome" required={true} />
								<FormGroup
									id="surname"
									name="surname"
									label="Cognome"
									required={true}
								/>
								<FormGroup
									id="email"
									name="email"
									label="Email"
									type="email"
									required={true}
								/>
								<FormGroup
									id="mobile"
									name="mobile"
									label="Telefono"
									required={false}
								/>
							</div>
						</div>
					)}
					<div className="invoice-block">
						<h4 className="invoice-title">Indirizzo</h4>
						<div className="form">
							<FormGroupValue
								id="company"
								name="company"
								label="Ragione Sociale"
								value={formAddress.company}
								onChange={(e) =>
									setFormAddress({ ...formAddress, company: e.target.value })
								}
								required={true}
							/>
							<FormGroupValue
								id="vat"
								name="vat"
								label="P.Iva"
								value={formAddress.vat}
								onChange={(e) =>
									setFormAddress({ ...formAddress, vat: e.target.value })
								}
								required={true}
							/>
							<FormGroupValue
								id="sdi"
								name="sdi"
								label="Sdi"
								value={(formAddress.sdi || "").toUpperCase()}
								onChange={(e) =>
									setFormAddress({ ...formAddress, sdi: e.target.value.toUpperCase() })
								}
								inputProps={{
									autoCapitalize: "characters",
									style: { textTransform: "uppercase" },
								}}
								required={true}
							/>
							<FormGroupValue
								id="pec"
								name="pec"
								label="Pec"
								value={formAddress.pec}
								onChange={(e) =>
									setFormAddress({ ...formAddress, pec: e.target.value })
								}
							/>
							<FormGroupValue
								id="taxcode"
								name="taxcode"
								label="C.F."
								value={formAddress.taxcode}
								onChange={(e) =>
									setFormAddress({ ...formAddress, taxcode: e.target.value })
								}
							/>
							<FormGroupValue
								id="address"
								name="address"
								label="Indirizzo"
								value={formAddress.address}
								onChange={(e) =>
									setFormAddress({ ...formAddress, address: e.target.value })
								}
								required={true}
							/>
							<FormGroupValue
								id="number"
								name="number"
								label="Civico"
								value={formAddress.number}
								onChange={(e) =>
									setFormAddress({ ...formAddress, number: e.target.value })
								}
								required={true}
							/>
							<FormGroupValue
								id="zipcode"
								name="zipcode"
								label="Cap"
								value={formAddress.zipcode}
								onChange={(e) =>
									setFormAddress({ ...formAddress, zipcode: e.target.value })
								}
								required={true}
							/>
							<FormGroupValue
								id="city"
								name="city"
								label="Città"
								value={formAddress.city}
								onChange={(e) =>
									setFormAddress({ ...formAddress, city: e.target.value })
								}
								required={true}
							/>
							<FormGroupValue
								id="province"
								name="province"
								label="Provincia"
								value={(formAddress.province || "").toUpperCase().slice(0, 2)}
								onChange={(e) =>
									setFormAddress({
										...formAddress,
										province: e.target.value.toUpperCase().slice(0, 2),
									})
								}
								inputProps={{
									maxLength: 2,
									autoCapitalize: "characters",
									style: { textTransform: "uppercase" },
								}}
								required={true}
							/>
						</div>
					</div>
					<button className="button button-2 success mt-2">Salva</button>
				</form>
			</div>
		</PopUp>
	);
}

export default InvoiceFormPopup;
